import React from 'react';
import { LeadsFormList } from '@moxie/shared';

const ListLeadsForm: React.FC = () => {
  return <LeadsFormList />;
};

export default ListLeadsForm;
